var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "page"
    },
    on: {
      "scroll": function scroll($event) {
        return _vm.winScroll($event);
      }
    }
  }, [_c('div', {
    staticClass: "scroll-content"
  }, [_c('headerBox', {
    ref: "headerBox",
    attrs: {
      "in-preview": _vm.inPreview,
      "only-show-selected": _vm.onlyShowSelected,
      "show-nav": _vm.product.showNav,
      "condition-id": _vm.product.condition,
      "shop-name": _vm.shopName
    },
    on: {
      "switchnav": _vm.switchNav,
      "switchcity": _vm.switchCity,
      "getuserdata": _vm.getUserData
    }
  }), _vm.carefullyData.show ? _c('carefullyBox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showProductListTitle,
      expression: "showProductListTitle"
    }],
    attrs: {
      "only-show-selected": _vm.onlyShowSelected,
      "list": _vm.carefullyData.list,
      "end": _vm.carefullyData.end,
      "is-empty": _vm.carefullyData.empty,
      "target-id": _vm.oldData && _vm.oldData.goodsId,
      "in-preview": _vm.inPreview
    },
    on: {
      "todetail": _vm.toProductAddress,
      "totargetgoods": _vm.toTargetGoods,
      "remove": _vm.removeCarefully,
      "totop": _vm.toTopCarefully
    }
  }) : _vm._e(), _vm.product.list.length > 0 ? _c('productList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.onlyShowSelected,
      expression: "!onlyShowSelected"
    }],
    attrs: {
      "list": _vm.product.list,
      "target-id": _vm.oldData && _vm.oldData.goodsId,
      "in-preview": _vm.inPreview,
      "show-title": _vm.showProductListTitle
    },
    on: {
      "todetail": _vm.toProductAddress,
      "totargetgoods": _vm.toTargetGoods
    }
  }) : _vm._e(), _vm.page.empty && !_vm.onlyShowSelected ? _c('empty') : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.onlyShowSelected,
      expression: "!onlyShowSelected"
    }],
    staticClass: "tips",
    domProps: {
      "innerHTML": _vm._s(_vm.addMoreText)
    }
  })], 1), _c('extension', {
    attrs: {
      "in-preview": _vm.inPreview,
      "shop-name": _vm.shopName
    }
  }), _c('myShopFooter')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };